import { useState, useEffect, useCallback } from 'react';
import { notification, Button, Space, Tag } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import "./RolesList.scss";
import service from '../../services/Service.js';
import { withLocale } from '../../l10n/index.jsx';
import DataTable from '../DataTable/index.js';
import DeleteButton from '../DeleteButton/DeleteButton.jsx';
import withNavigation from '../hooks/withNavigation.jsx';
import { GetColumnLiteralSearchProps } from '../../utils/functions.jsx';
import { useDispatch } from 'react-redux';
import { lookupApi } from '../../services/lookupApi.js';

function RolesList({ lang, navigate }) {

  // ===== 1. ESTADOS =====
  const [ui, setUI] = useState({
    loading: false,
  });

  const [data, setData] = useState({
    datos: [],
    selectedUuid: null,
  });

  // ====== 2. SELECTORES/HOOKS ======
  const dispatch = useDispatch();

  // ===== 3. DERIVADOS (Computados) =====
  const botonDisabled = !data.selectedUuid;

  // ===== 4. HELPERS (Para actualizar estado) =====
  const updateUI = (field, value) => setUI(prev => ({ ...prev, [field]: value }));
  const updateData = (field, value) => setData(prev => ({ ...prev, [field]: value }));

  // ===== 5. FUNCIONES PRINCIPALES =====
  const Pfetch = useCallback(async () => {
    updateUI('loading', true);
    try {
      const res = await service.get('roles');
      let rolesData = [];

      if (!res || res.data.ok === false) {
        notification["error"]({
          message: lang.handle(res?.data?.message || 'Error al obtener los datos'),
        });
      } else {
        rolesData = res.data;
      }
      updateData('datos', rolesData);
    } catch (err) {
      console.error("Error devuelto: " + err);
    } finally {
      updateUI('loading', false);
    }
  }, [lang]);

  // ===== 6. HANDLERS =====
  const deleteRole = async () => {
    updateUI('loading', true);
    try {
      const res = await service.del('roles/' + data.selectedUuid, data.selectedUuid);
      if (res.data.ok === false) {
        notification["error"]({
          message: lang.handle(res.data.message),
        });
      } else {
        notification["success"]({
          message: lang.handle('Rol borrado correctamente'),
        });
        dispatch(lookupApi.util.invalidateTags(['Roles']));
      }
      await Pfetch();
      updateData('selectedUuid', null);
    } catch (err) {
      console.error('Error devuelto: ' + err);
    } finally {
      updateUI('loading', false);
    }
  };

  const updateRole = () => {
    updateUI('loading', true);
    navigate(`/users/roles/config/${data.selectedUuid}`);
  };

  // ===== 7. EFFECTS =====
  useEffect(() => {
    Pfetch();
  }, [Pfetch]);

  // ===== 8. CONFIG (columnas, etc) =====
  const onSelectionChange = (selectedRowKeys, selectedRows) => {
    updateData('selectedUuid', selectedRows.length > 0 ? selectedRows[0].uuid : null);
  };

  const columns = [
    {
      title: lang.handle('Rol'),
      dataIndex: 'name',
      ...GetColumnLiteralSearchProps('name', lang),
    },
    {
      title: lang.handle('Administrador'),
      dataIndex: 'admin',
      render: (value) => <Tag className='admin'>{value ? lang.handle('Rol administrador') : ""}</Tag>,
    },
  ];

  const selection = {
    type: "radio",
    selectedRowKeys: data.selectedUuid ? [data.selectedUuid] : [],
    onChange: onSelectionChange,
  };

  // ===== 9. RENDER =====
  return (
    <div>
      <Button
        className='new'
        type="primary"
        onClick={() => navigate('/users/roles/config')}
      >
        {lang.handle('Nuevo Rol')}
      </Button>
      <DataTable
        rowSelection={selection}
        columns={columns}
        dataSource={data.datos}
        rowKey="uuid"
        loading={ui.loading}
      />
      <div className="button-panel">
        <Space>
          <Button
            type="primary"
            icon={<FormOutlined />}
            disabled={botonDisabled}
            onClick={updateRole}
          >
            {lang.handle('Editar')}
          </Button>

          <DeleteButton
            onEvent={deleteRole}
            buttonDisabled={botonDisabled}
          />

        </Space>
      </div>
    </div>
  );
}

export default withLocale(withNavigation(RolesList));
